import {
  Button,
  Card,
  Header,
  Icon,
  Message,
  Segment,
} from 'semantic-ui-react';
import React, { useCallback } from 'react';
import Label from 'components/Label/Label';
import { useIndexedDB } from 'hooks/useIndexedDB';
import { v4 as uuidV4 } from 'uuid';
import { useTerminalID } from 'hooks/useTerminalID';

export default function TerminalIDPage() {
  const { createValue } = useIndexedDB('dropshipments', 'configuration');
  const { terminalID, getTerminalID } = useTerminalID();

  const createTerminalID = useCallback(
    async (event, data) => {
      createValue({ key: 'terminal-id', value: uuidV4() });
      await getTerminalID();
    },
    [createValue, getTerminalID],
  );

  return (
    <>
      <Card.Header>
        <Label>Identificación de máquina</Label>
        <Button primary disabled={!!terminalID} onClick={createTerminalID}>
          Generar ID
        </Button>
      </Card.Header>
      <Card.Content>
        {!!terminalID ? (
          <Segment placeholder>
            <Header size="huge" icon>
              <Icon name="vcard" color="teal" />
              {terminalID}
              <Header.Subheader>
                Este es el Terminal ID generado para esta máquina.
              </Header.Subheader>
            </Header>
          </Segment>
        ) : (
          <Message info>
            Esta máquina no tiene Terminal ID generado. Por favor, pulsa el
            botón "Generar ID".
          </Message>
        )}
      </Card.Content>
    </>
  );
}
